import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ActiveRouteClassDirective } from './directives/active-route-class.directive';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { AtsCopyElementToClipboard } from './directives/copy-element-to-clipboard.directive';
import { AtsGlobalEventDirective } from './directives/document-event.directive';
import { AtsLazyImageDirective } from './directives/lazy-image.directive';
import { ResponsiveDirective } from './directives/responsive.directive';
import { ScrollIntoViewDirective } from './directives/scroll-into-view.directive';
import {
	AtsArrayHasItemPipe,
	AtsBooleanPipe,
	AtsFileReaderPipe,
	AtsFilterByIdPipe,
	AtsOrderByPropPipe,
	AtsReverseArrayPipe,
	AtsSplitPascalPipe,
	AtsTrackByPropertyPipe,
} from './pipes';
import { AtsFilterByPropPipe } from './pipes/filter-by-prop.pipe';
import { AtsObjectKeysPipe } from './pipes/object-keys.pipe';
import { AtsPropHasValuePipe } from './pipes/prop-has-value.pipe';
import { AtsSafeHtmlPipe } from './pipes/safe-html.pipe';
import { AtsFileUploadService } from './services/file-upload.service';
import { AtsOperatorService } from './services/operator.service';
import { AtsResponsiveService } from './services/responsive.service';
import { AtsUtilityService } from './services/utility.service';
import { UTILITY_CONFIG } from './tokens';
import { AtsUtilityConfig } from './models';

const imports = [CommonModule];

const providers = [
	AtsArrayHasItemPipe,
	AtsBooleanPipe,
	AtsFileReaderPipe,
	AtsFileUploadService,
	AtsFilterByIdPipe,
	AtsFilterByPropPipe,
	AtsOperatorService,
	AtsOrderByPropPipe,
	AtsResponsiveService,
	AtsSafeHtmlPipe,
	AtsSplitPascalPipe,
	AtsUtilityService,
];

const declarations = [
	ActiveRouteClassDirective,
	AtsArrayHasItemPipe,
	AtsBooleanPipe,
	AtsCopyElementToClipboard,
	AtsFileReaderPipe,
	AtsFilterByIdPipe,
	AtsFilterByPropPipe,
	AtsGlobalEventDirective,
	AtsLazyImageDirective,
	AtsObjectKeysPipe,
	AtsOrderByPropPipe,
	AtsPropHasValuePipe,
	AtsReverseArrayPipe,
	AtsSafeHtmlPipe,
	AtsSplitPascalPipe,
	AtsTrackByPropertyPipe,
	AutoFocusDirective,
	ResponsiveDirective,
	ScrollIntoViewDirective,
];

@NgModule({
	imports,
	providers,
	declarations,
	exports: [...declarations],
})
export class AtsUtilityModule {
	public static forRoot(config?: AtsUtilityConfig): ModuleWithProviders<AtsUtilityModule> {
		return {
			ngModule: AtsUtilityModule,
			providers: [
				...providers,
				{
					provide: UTILITY_CONFIG,
					useValue: { defaultDelayInMS: 7000, splitPascalExceptions: [], ...config },
				},
			],
		};
	}
}
